export default __webpack_public_path__ + "static/media/rocket_anim_158.c5f6d9a3.png";